import { getters } from '../store';

export default {
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },

  computed: {
    /**
     * Returns online exclusive flag
     * @returns {boolean} online exclusive flag
     */
    onlineExclusive() {
      return this.product && this.product.bylOnlineExclusive === true;
    },

    /**
     * Returns Coming soon flag
     * @returns {boolean} coming soon flag
     */
    comingSoon() {
      return this.product && this.product.bylComingSoon === true;
    },

    /**
     * Returns whether the product is sold out
     * @returns {boolean} true if the product is sold out
     */
    isSoldOut() {
      return !this.product.available;
    },

    /**
     * Returns whether the product is coming soon (sold out + coming soon flag)
     * @returns {boolean} true if the product is coming soon
     */
    isComingSoon() {
      return this.isSoldOut && this.product.bylComingSoon;
    },

    /**
     * Returns whether the product is online exclusive
     * @returns {boolean} true if the product is online exclusive
     */
    isOnlineExclusive() {
      return this.product.bylOnlineExclusive;
    },

    /**
     * Returns the custom tag value of the product
     * @returns {string|undefined} custom tag value or undefined
     */
    customTag() {
      return this.product?.bylCustomTag;
    },

    /**
     * Returns whether the product has a custom tag
     * @returns {boolean} true if the product has a custom tag
     */
    isCustomTag() {
      return (
        this.product && this.customTag !== undefined && this.customTag !== null
      );
    },

    /**
     * Returns whether the custom tag should be visible in the current category
     * @returns {boolean} true if the custom tag is visible in the current category
     */
    isCustomTagVisibleInCategory() {
      if (!this.isCustomTag) return false;
      if (this.gridType === 'search') return true;
      const plpCategory =
        this.$store.getters[getters.productList.currentCategory];
      const categoryId = parseInt(plpCategory?.id, 10);
      return (
        !categoryId || !this.customTag?.hide_in_categories?.includes(categoryId)
      );
    },

    /**
     * Returns the Wanna iframe URL for the product
     * @returns {string|undefined} Wanna iframe URL or undefined
     */
    iframeUrl() {
      return this.product?.bylWannaUrl;
    },
  },

  methods: {},
};
